import React from 'react';
import useOrganizationPaymentIntegration from '../../../../../../hooks/api/useOrganizationPaymentIntegration';
import { AnimateLoadedContent } from '../../../../../v2BaseComponents/Loader';
import NotSetupContent from './NotSetupContent';
import RestrictedContent from './RestrictedContent';
import SetupContent from './SetupContent';

export type ClientBillingOwnProps = {};

export type ClientBillingProps = ClientBillingOwnProps;

const ClientBilling: React.FC<ClientBillingProps> = (_props) => {
    const { isLoadingPaymentIntegrationStatus, paymentIntegrationStatus } = useOrganizationPaymentIntegration({});

    return (
        <AnimateLoadedContent isLoading={isLoadingPaymentIntegrationStatus || !paymentIntegrationStatus}>
            {() =>
                paymentIntegrationStatus?.status === 'not-setup' ? (
                    <NotSetupContent />
                ) : paymentIntegrationStatus?.status === 'restricted' ? (
                    <RestrictedContent />
                ) : (
                    <SetupContent />
                )
            }
        </AnimateLoadedContent>
    );
};

export default React.memo(ClientBilling);
